import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

// Предохранитель вокруг страниц: без него ЛЮБАЯ ошибка рендера (например,
// календарь, которому пришли пустые даты) размонтирует всё дерево, и человек
// видит белый экран без единой подсказки. Здесь ошибка остаётся внутри
// контента — шапка и меню живут, текст ошибки видно, страницу можно
// перезагрузить.
type Props = { children: ReactNode; resetKey?: string };
type State = { error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(prev: Props) {
    // Ушли на другой путь — даём странице шанс отрисоваться заново.
    if (this.state.error && prev.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("UI crashed:", error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="card p-6 flex flex-col items-start gap-3">
        <div className="flex items-center gap-2 text-rose-600 dark:text-rose-400">
          <AlertTriangle className="h-5 w-5" />
          <span className="font-semibold">Страница не отрисовалась</span>
        </div>
        <div className="text-sm text-ink-600 dark:text-ink-300">
          {error.message || "Неизвестная ошибка"}
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            className="btn"
            onClick={() => this.setState({ error: null })}
          >
            Попробовать снова
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => window.location.reload()}
          >
            Перезагрузить
          </button>
        </div>
      </div>
    );
  }
}
